import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { useRouter } from 'next/router';

export interface Tabs {
  id: number;
  text: string;
  path: string;
}

interface TabMenuProps {
  tabs: Array<Tabs>;
}

const TabLayout = styled.div`
  text-align: center;
  margin-bottom: 48px;
`;

const TabBox = styled.div`
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.palette.paleGray};
  border-radius: 28px;
  background-color: ${({ theme }) => theme.palette.whiteGray};

  a {
    width: 154px;
    height: 48px;
    margin: 0;
    border: transparent;
    border-radius: 25px;
    box-shadow: none;
    background-color: transparent;
    color: ${({ theme }) => theme.palette.gray};
    font-size: 15px;
    line-height: 48px;

    &.active {
      border: solid 1px ${({ theme }) => theme.palette.primary};
      background-color: ${({ theme }) => theme.palette.primary};
      color: ${({ theme }) => theme.palette.white};
    }
  }
`;

function TabMenu({ tabs }: TabMenuProps) {
  const router = useRouter();

  return (
    <TabLayout>
      <TabBox>
        {tabs.map(({ id, text, path }) => {
          const { pathname } = new URL(APP_URL + router.asPath);
          const isSelected = pathname === path;
          return (
            <Link href={path} passHref key={id}>
              <a href={path} className={isSelected ? 'active' : ''}>
                {text}
              </a>
            </Link>
          );
        })}
      </TabBox>
    </TabLayout>
  );
}

export default TabMenu;

const { APP_URL } = process.env;
